import {useContext} from 'react';
import IntlConfigContext from 'src/internal/config/IntlConfigContext';
import defaultConfig from 'src/internal/config/defaultConfig';

export default function useHasIntlProvider(): boolean {
  const config = useContext(IntlConfigContext);

  return config !== defaultConfig;
}
